import { observable } from 'mobx';

export interface OnlineApplicationBillingArgs {
  is_billing_same_as_company: boolean;
  id?: number;
  online_application_id?: number;
  postal_address: string;
  address: string;
  tel: string;
  department: string;
  contact_name: string;
  contact_name_kana: string;
  contact_tel: string;
  contact_email: string;
  bank_name: string;
  branch_name: string;
  account_type: string;
  account_number: string;
  account_holder_name: string;
  created_at?: string;
  updated_at?: string;
}

export class OnlineApplicationBilling {
  @observable isBillingSameAsCompany: boolean;
  @observable id?: number;
  @observable onlineApplicationId?: number;
  @observable postalAddress: string;
  @observable address: string;
  @observable tel: string;
  @observable department: string;
  @observable contactName: string;
  @observable contactNameKana: string;
  @observable contactTel: string;
  @observable contactEmail: string;
  @observable bankName: string;
  @observable branchName: string;
  @observable accountType: string;
  @observable accountNumber: string;
  @observable accountHolderName: string;
  @observable createdAt?: string;
  @observable updatedAt?: string;

  constructor(args: Partial<OnlineApplicationBillingArgs> = {}) {
    this.isBillingSameAsCompany = args.is_billing_same_as_company || false;
    this.id = args.id;
    this.onlineApplicationId = args.online_application_id;
    this.postalAddress = args.postal_address || '';
    this.address = args.address || '';
    this.tel = args.tel || '';
    this.department = args.department || '';
    this.contactName = args.contact_name || '';
    this.contactNameKana = args.contact_name_kana || '';
    this.contactTel = args.contact_tel || '';
    this.contactEmail = args.contact_email || '';
    this.bankName = args.bank_name || '';
    this.branchName = args.branch_name || '';
    this.accountType = args.account_type || '';
    this.accountNumber = args.account_number || '';
    this.accountHolderName = args.account_holder_name || '';
    this.createdAt = args.created_at;
    this.updatedAt = args.updated_at;
  }

  // 口座種別の表示名
  get accountTypeLabel(): string {
    const typeValue = String(this.accountType);
    switch (typeValue) {
      case '1':
      case 'ordinary':
        return '普通';
      case '2':
      case 'checking':
        return '当座';
      default:
        return '';
    }
  }
}

export default OnlineApplicationBilling;
